import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _get from "lodash/get";
import * as Sentry from '@sentry/browser';
import { ExtraErrorData } from '@sentry/integrations';
var ID;
var ACCESS;
var isInitialized;
var toExcludeErrorsWith = ['socket closed', 'socket error'];
var beforeSend = function beforeSend(event, hint) {
  var message = _get(hint, 'originalException.error.errorMessage', '').toLowerCase() || _get(hint, 'originalException.error.message', '').toLowerCase();
  if (toExcludeErrorsWith.some(function (errorToExclude) {
    return message.includes(errorToExclude);
  })) {
    return null;
  }
  return event;
};
export var isServiceInitialized = function isServiceInitialized() {
  return isInitialized;
};
export var initializeErrorReporting = function initializeErrorReporting(_ref) {
  var credentials = _ref.credentials,
    excludeErrorsIncluding = _ref.excludeErrorsIncluding,
    _ref$environment = _ref.environment,
    environment = _ref$environment === void 0 ? 'unknown' : _ref$environment,
    _ref$project = _ref.project,
    project = _ref$project === void 0 ? 'default' : _ref$project;
  if (!credentials) {
    throw Error('credentials are mandatory');
  }
  if (excludeErrorsIncluding) {
    toExcludeErrorsWith.push.apply(toExcludeErrorsWith, _toConsumableArray(excludeErrorsIncluding));
  }
  if (!isInitialized) {
    ID = credentials.id;
    ACCESS = credentials.access;
    isInitialized = true;
    Sentry.init({
      dsn: "https://" + ACCESS + "@" + (credentials.path || '') + "sentry.io/" + ID,
      beforeSend: beforeSend,
      environment: environment + "-" + project,
      integrations: [new ExtraErrorData({
        depth: 30
      })]
    });
  }
};
export var setUser = function setUser(_ref2) {
  var email = _ref2.email;
  if (isInitialized) {
    Sentry.setUser({
      email: email
    });
  }
};
export var sendInternalError = function sendInternalError(message, errorObj) {
  if (isInitialized) {
    Sentry.captureException(new Error(message), function (scope) {
      if (errorObj) {
        scope.setContext('errorObject', errorObj);
      }
      return scope;
    });
  }
};